var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.list),function(item){return _c('li',{key:item.id,staticClass:"mb-2 last:mb-0",class:{ 'text-ccc': _vm.disabled }},[_c('sort-item',{attrs:{"item":item,"index":item.index},nativeOn:{"click":function($event){return _vm.onChangeState(item)}}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }